export const FETCH_BOOKINGS = 'FETCH_BOOKINGS';
export const SET_BOOKINGS = 'SET_BOOKINGS';
export const SET_BOOKINGS_LOADING = 'SET_BOOKINGS_LOADING';
export const SET_ALERT = 'SET_ALERT';
export const PERFORM_BOOKING_ACTION = 'PERFORM_BOOKING_ACTION';
export const MAKE_BOOKING = 'MAKE_BOOKING';
export const SET_BOOKING_FORM_FIELD = 'SET_BOOKING_FORM_FIELD';
export const CLEAR_BOOKINGS_FORM = 'CLEAR_BOOKINGS_FORM ';
export const SET_BOOKINGS_REQUEST_TIMESTAMP = 'SET_BOOKINGS_REQUEST_TIMESTAMP';
export const FETCH_BOOKING = "FETCH_BOOKING";
export const SET_BOOKING = "SET_BOOKING";
export const FETCH_SURVEY_QUESTIONS = "FETCH_SURVEY_QUESTIONS";
export const SET_SURVEY_QUESTIONS = "SET_SURVEY_QUESTIONS";
export const SAVE_BOOKING_ATTRIBUTES = "SAVE_BOOKING_ATTRIBUTES";
export const FETCH_PRACTITIONER_AVAILABILITY = "FETCH_PRACTITIONER_AVAILABILITY";
export const SET_PRACTITIONER_AVAILABILITY = "SET_PRACTITIONER_AVAILABILITY";
export const CLEAR_PRACTITIONER_AVAILABILITY = "CLEAR_PRACTITIONER_AVAILABILITY";
export const MAKE_CALENDAR_BOOKING = 'MAKE_CALENDAR_BOOKING';
export const MAKE_INSTANT_BOOKING = 'MAKE_INSTANT_BOOKING';
export const CANCEL_CALENDAR_BOOKING = 'CANCEL_CALENDAR_BOOKING';
export const RESCHEDULE_BOOKING = 'RESCHEDULE_BOOKING';
export const RESCHEDULE_CALENDAR_BOOKING = 'RESCHEDULE_CALENDAR_BOOKING';
export const FETCH_LATEST_INSTANT_BOOKINGS = 'FETCH_LATEST_INSTANT_BOOKINGS';
export const SET_INSTANT_BOOKINGS = 'SET_INSTANT_BOOKINGS';

export const fetchBookings = () => ({type: FETCH_BOOKINGS});
export const performBookingAction = (bookingId, action) => ({type: PERFORM_BOOKING_ACTION, payload: {bookingId, action}});
export const setBookings = (bookings, timestamp=null) => ({type: SET_BOOKINGS, payload: bookings, timestamp});
export const setBookingsLoading = (value) => ({type: SET_BOOKINGS_LOADING, payload: value});
export const setAlert = (alert) => ({type: SET_ALERT, payload: alert});
export const makeBooking = (booking) => ({type: MAKE_BOOKING, payload: booking});
export const setBookingFormField = (field, value) => ({type: SET_BOOKING_FORM_FIELD, payload: {field, value}});
export const clearBookingsForm = () => ({type: CLEAR_BOOKINGS_FORM});
export const setBookingsRequestTimestamp = (timestamp) => ({type: SET_BOOKINGS_REQUEST_TIMESTAMP, payload: timestamp})
export const FETCH_CONSULTS = 'FETCH_CONSULTS';
export const fetchConsults = () => ({type: FETCH_CONSULTS});
export const fetchBooking = (bookingId) => ({type: FETCH_BOOKING, payload: bookingId})
export const setBooking = (booking, timestamp) => ({type: SET_BOOKING, payload: booking, timestamp})
export const fetchSurveyQuestions = (booking_id) => ({type: FETCH_SURVEY_QUESTIONS, payload: booking_id})
export const setSurveyQuestions = (questions) => ({type: SET_SURVEY_QUESTIONS, payload: questions})
export const saveBookingAttributes = (payload) => ({type: SAVE_BOOKING_ATTRIBUTES, payload})
export const fetchPractitionerAvailability = (practitioner) => ({type: FETCH_PRACTITIONER_AVAILABILITY, payload: practitioner})
export const clearPractitionerAvailability = () => ({type: CLEAR_PRACTITIONER_AVAILABILITY})
export const setPractitionerAvailability = (availability) => ({type: SET_PRACTITIONER_AVAILABILITY, payload: availability})
export const makeCalendarBooking = (booking) => ({type: MAKE_CALENDAR_BOOKING, payload: booking});
export const makeInstantBooking = (booking) => ({type: MAKE_INSTANT_BOOKING, payload: booking});
export const cancelCalendarBooking = (p) => ({type: CANCEL_CALENDAR_BOOKING, payload: p});
export const rescheduleBooking = (p) => ({type: RESCHEDULE_BOOKING, payload: p});
export const rescheduleCalendarBooking = (p) => ({type: RESCHEDULE_CALENDAR_BOOKING, payload: p});
export const fetchLatestInstantBookings = () => ({type: FETCH_LATEST_INSTANT_BOOKINGS});
export const setInstantBookings = (bookings, timestamp=null) => ({type: SET_INSTANT_BOOKINGS, payload: bookings});